import React, { useEffect, useState } from "react";
import splashLogo from "../../static/CUC_LOGO_NEW.svg";
import "./style.css";

export function SplashScreen() {
  const [isVisible, setIsVisible] = useState(() => {
    if (typeof document === "undefined") {
      return false;
    }

    return !document.getElementById("cuc-splash-bootstrap");
  });

  useEffect(() => {
    document.body.classList.add("splash-screen-lock-scroll");

      const timer = window.setTimeout(() => {
      const bootstrapSplash = document.getElementById("cuc-splash-bootstrap");

      if (bootstrapSplash) {
        bootstrapSplash.classList.add("is-hidden");
        window.setTimeout(() => {
          bootstrapSplash.remove();
        }, 260);
      }

      setIsVisible(false);

      // Ensure the page theme color is set to the app's fixed color after the splash
      try {
        const themeMeta = document.querySelector('meta[name="theme-color"]');
        if (themeMeta) themeMeta.setAttribute("content", "#171923");
      } catch (e) {
        // ignore
      }

      window.setTimeout(() => {
        document.body.classList.remove("splash-screen-lock-scroll");
      }, 260);
    }, 1500);

    return () => {
      window.clearTimeout(timer);
      document.body.classList.remove("splash-screen-lock-scroll");
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="splash-screen" aria-hidden="true">
      <div className="splash-screen__logo-wrap">
        <img
          className="splash-screen__logo"
          src={splashLogo}
          alt="CUC Fitness Studio"
        />
      </div>
    </div>
  );
}